module.exports = __webpack_public_path__ + "img/detail-banner-title-end.e443d0e3.png";